import { useCallback } from 'react';

import { Filter, FilterResultStatus } from '@/components/filter';
import { Selector } from '@/components/selector';

import { MODULES } from '@/constants';

import { useAuditLogsListStore } from '@/store/audit-logs-list.store';
import { type CallModeValue } from '@/store/calls-list.store';
import type { AuditLog } from '@/types/audit-log.type';

const AuditLogModuleFilter = () => {
  const { filters, setFilter } = useAuditLogsListStore();

  return (
    <Selector
      options={[{ value: 'All', label: 'All Modules' }, ...MODULES]}
      value={filters.module}
      onChange={value => setFilter('module', value as CallModeValue)}
    />
  );
};

export const AuditLogHeader = ({ logs }: { logs: AuditLog[] }) => {
  const { setQuery, query, filters, reset } = useAuditLogsListStore();

  const handleClearQuery = useCallback(() => setQuery(''), [setQuery]);

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-3">
        <Filter
          placeholder="Search by user email..."
          onFilter={setQuery}
          initialValue={query}
          onClear={handleClearQuery}
        />
        <AuditLogModuleFilter />
      </div>

      {(query || filters.module !== 'All') && (
        <FilterResultStatus
          resultsCount={logs.length}
          onReset={reset}
          message="No logs match your search"
        />
      )}
    </div>
  );
};
